import { AbstractGenericStore } from "./GenericStoreClass";

interface SaveableStore<K, T> {
  save(key: K): Promise<boolean>;
  saveByValue(value: T): Promise<boolean>;
  saveAll(): Array<Promise<boolean>>;
}
abstract class AbstractSaveableStore<K, T extends object>
  extends AbstractGenericStore<K, T>
  implements SaveableStore<K, T>
{
  saveAll(): Array<Promise<boolean>> {
    return this.values.map((x) => this.saveByValue(x));
  }

  save(key: K): Promise<boolean> {
    // get value by key
    const value: T | undefined = this.getWithoutLookup(key);

    if (!value) {
      throw new Error(
        "Cannot save an object by Id if its not in the Store already",
      );
    }

    return this.saveByValue(value);
  }

  abstract saveByValue(value: T): Promise<boolean>;
}

export { AbstractSaveableStore, SaveableStore };
